import styled from "styled-components"
import { LeftOutline } from 'antd-mobile-icons'
import { Ellipsis } from 'antd-mobile'
import { debounce, throttle } from 'lodash'
import { useNavigate } from "react-router-dom"

const NavigatorStyled = styled.div`
    height: 44px;
    position: relative;
    background-color: #fff;
    .top-title {
        font-size: 16px;
        width: 176px;
        text-align: center;
    }
    .back {
        left: 12px;
        position: absolute;
        width: 18px;
        height: 18px;
    }
`

const Navigator = (props) => {
    const { title, onBack } = props
    const navigate = useNavigate()

    const back = throttle(() => {
        if (onBack) {
            onBack()
        } else {
            navigate(-1)
        }
    }, 2000)

    const handleBack = () => {
        back()
    }
    return <NavigatorStyled className="flex-center">
        <div onClick={handleBack} className="back">
            <LeftOutline fontSize={18} className='left-icon' />
        </div>
        <div className="top-title">
            <Ellipsis direction='end' content={title || '了了简历'} />
        </div>
    </NavigatorStyled>
}

export default Navigator